import React__default from 'react';

const Input = props => {
  const {
    placeholder,
    label,
    helpLabel,
    startIcon,
    endIcon,
    readOnly,
    error,
    ...restProps
  } = props;
  const inputClasses = ['voyage-input'];
  if (startIcon) inputClasses.push('voyage-input--padding-start');
  if (endIcon) inputClasses.push('voyage-input--padding-end');
  if (error) inputClasses.push('voyage-input--error');
  return /*#__PURE__*/React__default.createElement("div", {
    className: "voyage-input__group"
  }, /*#__PURE__*/React__default.createElement("label", null, label || helpLabel && (/*#__PURE__*/React__default.createElement("div", {
    className: "voyage-input__label-group"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "voyage-input__label"
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: "voyage-input__help"
  }, helpLabel))), /*#__PURE__*/React__default.createElement("div", {
    className: "voyage-input__wrap"
  }, startIcon && /*#__PURE__*/React__default.createElement("span", {
    className: "voyage-input__icon  voyage-input__icon--start"
  }, startIcon), /*#__PURE__*/React__default.createElement("input", {
    className: inputClasses.join(' '),
    placeholder: placeholder,
    type: "text",
    readOnly: readOnly,
    ...restProps
  }), endIcon && /*#__PURE__*/React__default.createElement("span", {
    className: "voyage-input__icon voyage-input__icon--end"
  }, endIcon))), error && /*#__PURE__*/React__default.createElement("div", {
    className: "voyage-input__error"
  }, error));
};

export { Input as default };
//# sourceMappingURL=Input.esm.js.map
